<template lang="pug">
BriqPanel
  BriqMultilangueColumns(:showSecondColumn="showSecondColumn")
    h2.mb-S Resource
    BriqMultiselect(
      label="Resource"
      v-model="innerValue"
      required="required"
      :valueSetter="r => r.Key"
      :options="resourceOptions"
      :error="resourceKeyError"
      track-by="Key"
      display="Description"
      name="ResourceKey"
      :disabled="disabled"
      data-test-id="select-resource"
      )
      template(slot="singleLabel" slot-scope="props")
        BriqMultiselectWarningLabel(
          data-test-id="resource-field-warning-label"
          :label="props.option['Description']"
          :shouldShowWarning="shouldShowWarning"
          warningLabel="Inactive resource"
          )
</template>

<script>
import BriqMultilangueColumns from '@v/components/BriqMultilanguageColumns.vue'
import BriqMultiselectWarningLabel from '@v/components-global/BriqMultiselect/BriqMultiselectWarningLabel.vue'
import { pipe, propEq, prop, find } from 'ramda'
import { filterByProp } from '@v/util/briqRamdaExt.js'
import { maybeAppendResource } from './utils/maybeAppendResource.js'

export default {
  name: 'ResourceField',
  components: { BriqMultilangueColumns, BriqMultiselectWarningLabel },
  props: {
    value: String,
    disabled: Boolean,
    resources: { type: Array },
    showSecondColumn: Boolean,
    resourceKeyError: String,
  },
  computed: {
    resourceOptions() {
      return this.getResourceOptions(this.resources)
    },
    innerValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('resourceSelected', v)
      },
    },
    selectedResourceObject() {
      return find(propEq('Key', this.innerValue))(this.resources)
    },
    shouldShowWarning() {
      return !this.selectedResourceObject?.IsActive
    },
  },
  methods: {
    getResourceOptions(resources) {
      return pipe(
        filterByProp('IsActive'),
        maybeAppendResource(this.selectedResourceObject),
      )(resources)
    },
  },
}
</script>
